import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../hooks/useCustomSneakbar';
import moment from 'moment';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Modal from '../components/Modal';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { GeneratePdf } from '../components/GeneratePdf';

const AIBasedTeachingPlan = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const initialFormState = {
        syllabusStructureMasterId: '',
        subjectMasterId: '',
        lessonMasterId: '',
        details: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [teachingData, setTeachingData] = useState(initialFormState)
    const [teachingPlan, setTeachingPlan] = useState({})
    const [editId, setEditId] = useState(null)

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        getTeachingPlan();
    }, [teachingData.syllabusStructureMasterId, teachingData.subjectMasterId, teachingData.lessonMasterId]);

    const getTeachingPlan = async () => {
        if (teachingData.syllabusStructureMasterId.length !== 0 && teachingData.subjectMasterId.length !== 0 && teachingData.lessonMasterId.length !== 0) {
            let apiUrl = '/view-teaching-plan?';
            if (teachingData.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${teachingData.syllabusStructureMasterId}&`;
            }
            if (teachingData.subjectMasterId) {
                apiUrl += `subjectMasterId=${teachingData.subjectMasterId}&`
            }
            if (teachingData.lessonMasterId) {
                apiUrl += `lessonMasterId=${teachingData.lessonMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            try {
                const response = await authorizedAxios.get(apiUrl);
                setTeachingPlan(response.data.result[0]);
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setTeachingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                lessonMasterId: ''
            }
        })
        setLessonList([]);

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setTeachingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: ''
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${teachingData.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setTeachingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setTeachingData((prevData) => {
            return {
                ...prevData,
                details: value
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(teachingData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(teachingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [teachingData])

    const addTeachingPlan = async () => {
        if (validateForm()) {
            setLoading(true);
            const apiUrl = `/add-teaching-plan`;
            try {
                const response = await authorizedAxios.post(apiUrl, teachingData);
                await getTeachingPlan();
                setTeachingData((prevData) => {
                    return {
                        ...prevData,
                        details: ''
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(teachingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteTeachingPlan = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-teaching-plan?id=${id}`;
            try {
                const response = await authorizedAxios.delete(apiUrl);
                await getTeachingPlan();
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(teachingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const updateTeachingPlan = async () => {
        if (validateForm()) {
            setLoading(true);
            const apiUrl = `/edit-teaching-plan?id=${editId}`;
            try {
                const response = await authorizedAxios.put(apiUrl, teachingData);
                setEditId(null);
                await getTeachingPlan();
                setTeachingData((prevData) => {
                    return {
                        ...prevData,
                        details: ''
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    setLoading(true);
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err.response.data.error);
                            })
                            .finally(() => {
                                setLoading(false); // End loading
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    const handleInputReset = () => {
        setTeachingData(initialFormState);
        setTeachingPlan({});
        setEditId('');
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>AI Based Teaching Plan</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-robot"></i>AI Based Teaching Plan</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={teachingData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusStructureMasterId && <p style={{ color: 'red' }}>{error.syllabusStructureMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={teachingData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleInputChange} value={teachingData.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.lessonMasterId && <p style={{ color: 'red' }}>{error.lessonMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Teaching Details :</label>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={teachingData.details}
                                                        onReady={editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            // console.log('Editor is ready to use!', editor);
                                                        }}
                                                        onChange={(event, editor) => {
                                                            handleDetailChange(editor)
                                                        }}

                                                        config={{
                                                            extraPlugins: [uploadPlugin],
                                                        }}

                                                        onInit={(editor) => {
                                                            uploadPlugin(editor);
                                                        }}
                                                    />
                                                    {error.details && <p style={{ color: 'red' }}>{error.details}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {
                                                            !editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTeachingPlan}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTeachingPlan} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                {teachingPlan && Object.keys(teachingPlan).length !== 0 &&
                                                    <div className="content_book_wraper">
                                                        <div className="header_group">
                                                            <GeneratePdf id="AIBasedTeachingPlan" title={teachingPlan} />
                                                            <div className="button_wrapper">
                                                                <button className="btn btn-outline-warning edit_icon" type="button"
                                                                    onClick={() => {
                                                                        setEditId(teachingPlan.id);
                                                                        setTeachingData({
                                                                            syllabusStructureMasterId: teachingPlan?.syllabusStructureMasterId,
                                                                            subjectMasterId: teachingPlan?.subjectMasterId,
                                                                            lessonMasterId: teachingPlan?.lessonMasterId,
                                                                            details: teachingPlan?.details
                                                                        })
                                                                    }}
                                                                >
                                                                    <i className="fa-light fa-pen-to-square"></i>
                                                                </button>
                                                                <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === teachingPlan.id} onClick={() => deleteTeachingPlan(teachingPlan.id)}>
                                                                    <i className="fa-light fa-trash-can"></i>
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div class="content_book_wrap" id='AIBasedTeachingPlan'>
                                                            <div className="row">
                                                                <div className="book">
                                                                    <div className='lesson_area'>
                                                                        <div className='lesson_no'>
                                                                            <div className='info'>
                                                                                <span className='capt'>Syllabus Structure:</span>
                                                                                <span className='value'>{teachingPlan?.AiTeachingPlanSyllabusStructureMasterDetails?.syllabusStructureName}</span>
                                                                            </div>
                                                                            <div className='info'>
                                                                                <span className='capt'>Subject:</span>
                                                                                <span className='value'>{teachingPlan?.subjectMasterDetails?.subjectName}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className='chapter_name'>
                                                                            <div className='info'>
                                                                                <span className='capt'>Lesson Name:</span>
                                                                                <span className='value'>{teachingPlan?.AiTeachingPlanLessonMasterDetails?.lessonName}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="page" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${teachingPlan?.details}</div>` }} ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AIBasedTeachingPlan;